/**
 * Ad Broadcast Service API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
 /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { AdPortalStatusDto } from '../model/adPortalStatusDto';
import { CaseBroadcastHistoryListItemDto } from '../model/caseBroadcastHistoryListItemDto';
import { CaseBroadcastSettingsDto } from '../model/caseBroadcastSettingsDto';
import { VPError } from '../model/vPError';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class CaseBroadcastSettingsViewService {

    protected basePath = '/';
    protected defaultHeaders = new HttpHeaders();
    protected configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param caseBroadcastSettingsId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAdPortalStatusesCaseBroadcastSettingsId(caseBroadcastSettingsId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<AdPortalStatusDto>>;
    public getAdPortalStatusesCaseBroadcastSettingsId(caseBroadcastSettingsId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AdPortalStatusDto>>>;
    public getAdPortalStatusesCaseBroadcastSettingsId(caseBroadcastSettingsId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AdPortalStatusDto>>>;
    public getAdPortalStatusesCaseBroadcastSettingsId(caseBroadcastSettingsId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (caseBroadcastSettingsId === null || caseBroadcastSettingsId === undefined) {
            throw new Error('Required parameter caseBroadcastSettingsId was null or undefined when calling getAdPortalStatusesCaseBroadcastSettingsId.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<AdPortalStatusDto>>(`${this.basePath}/api/CaseBroadcastSettingsView/${encodeURIComponent(String(caseBroadcastSettingsId))}/adPortalStatuses`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * AmsAction:GET/api/CaseBroadcastSettingsView/case/{caseId}/adPortal/{broadcastConfigurationConnectionId} AmsResource:{country}/{business}/case/{caseId} 
     * @param caseId 
     * @param broadcastConfigurationConnectionId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCaseBroadcastHistoryListItemDtoByCaseIdAndAdPortalId(caseId: string, broadcastConfigurationConnectionId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<CaseBroadcastHistoryListItemDto>>;
    public getCaseBroadcastHistoryListItemDtoByCaseIdAndAdPortalId(caseId: string, broadcastConfigurationConnectionId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CaseBroadcastHistoryListItemDto>>>;
    public getCaseBroadcastHistoryListItemDtoByCaseIdAndAdPortalId(caseId: string, broadcastConfigurationConnectionId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CaseBroadcastHistoryListItemDto>>>;
    public getCaseBroadcastHistoryListItemDtoByCaseIdAndAdPortalId(caseId: string, broadcastConfigurationConnectionId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (caseId === null || caseId === undefined) {
            throw new Error('Required parameter caseId was null or undefined when calling getCaseBroadcastHistoryListItemDtoByCaseIdAndAdPortalId.');
        }

        if (broadcastConfigurationConnectionId === null || broadcastConfigurationConnectionId === undefined) {
            throw new Error('Required parameter broadcastConfigurationConnectionId was null or undefined when calling getCaseBroadcastHistoryListItemDtoByCaseIdAndAdPortalId.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<CaseBroadcastHistoryListItemDto>>(`${this.basePath}/api/CaseBroadcastSettingsView/case/${encodeURIComponent(String(caseId))}/adPortal/${encodeURIComponent(String(broadcastConfigurationConnectionId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * AmsAction:GET/api/CaseBroadcastSettingsView/case/{caseId} AmsResource:{country}/{business}/case/{caseId} 
     * @param caseId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCaseBroadcastSettingsByCaseId(caseId: string, observe?: 'body', reportProgress?: boolean): Observable<CaseBroadcastSettingsDto>;
    public getCaseBroadcastSettingsByCaseId(caseId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CaseBroadcastSettingsDto>>;
    public getCaseBroadcastSettingsByCaseId(caseId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CaseBroadcastSettingsDto>>;
    public getCaseBroadcastSettingsByCaseId(caseId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (caseId === null || caseId === undefined) {
            throw new Error('Required parameter caseId was null or undefined when calling getCaseBroadcastSettingsByCaseId.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<CaseBroadcastSettingsDto>(`${this.basePath}/api/CaseBroadcastSettingsView/case/${encodeURIComponent(String(caseId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
